import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { MultiColumnCtaProps } from '@ahc-digital/component-library';
import { MULTI_COLUMN_CTA_CONTAINER } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from '@/shared/param-utils';
import { C05MulticolumnCTAsProps } from './C05MutlicolumnCTAs.types';

export function CreateMultiColumnCTAsModel(props?: C05MulticolumnCTAsProps) {
  const { renderRichText, renderText } = useConditionalRendering();
  type t = MultiColumnCtaProps;

  const { rendering, params, fields } = props || {};

  return {
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    columns: getDroplink(params?.NumberOfColumns, '2'),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentAlignment, 'left'),
    ctas: rendering ? (
      <Placeholder name={MULTI_COLUMN_CTA_CONTAINER} rendering={rendering} />
    ) : (
      <></>
    ),
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    removeColumnMobilePadding: getCheckbox(params?.RemoveColumnMobilePadding),
    supportCopy: renderRichText(fields?.SupportCopy),
  };
}
